import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ConfigService, EnvironmentConfig } from 'src/app/core/services/config.service';
@Injectable()
export class CarrierApiService {
  envConfig: Promise<EnvironmentConfig>;
  constructor(
    private http: HttpClient,
    private config: ConfigService
  ) {
    this.envConfig = this.config.getConfig();
  }

  private async getApiUrl() {
    const config = await this.envConfig;
    return config.runtime.carrierApiUrl;
  }

  public async getCarrierProfile(carrierId: string): Promise<object> {
    const apiUrl = await this.getApiUrl();
    const url = `${apiUrl}/carrier-profile/${carrierId}`;
    return this.http.get(url).toPromise();
  }

  public async getCarrierEquipment(carrierId: string): Promise<object> {
    const apiUrl = await this.getApiUrl();
    const url = `${apiUrl}/carrier-equipment/${carrierId}`;
    return this.http.get(url).toPromise();
  }

  public async getCarriersList(carrierNameOrMcNumber: string) {
    try {
      const apiUrl = await this.getApiUrl();
      // Check if the input is numeric
      const isNumeric = /^\d+$/.test(carrierNameOrMcNumber);
      // If it's numeric, use mcNumber, otherwise use carrierName
      const queryParam = isNumeric ? `mcNumber=${encodeURIComponent(carrierNameOrMcNumber)}` : `carrierName=${encodeURIComponent(carrierNameOrMcNumber)}`;
      const url = `${apiUrl}/carrier/search?${queryParam}`;
      return this.http.get(url).toPromise();
    } catch (error) {
      console.log('Error:', error);
      return [];
    }
}

  // get carrier user from email address
  public async getUserFromEmailAddress(email: string): Promise<any>{
    try {
      const apiUrl = await this.getApiUrl();
      const url = `${apiUrl}/user-profile/${email}`;
      return this.http.get(url).toPromise();
    } catch (error) {
      console.log('Error:', error);
      return {};
    }
  }

}
